import { createStore, applyMiddleware } from 'redux';
import createLogger from 'redux-logger';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
// import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/autoMergeLevel1';
// import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import rootReducers from '../reducers';

const persistConfig = {
    key: 'History',
    storage,
    // stateReconciler: autoMergeLevel2,
    whitelist: ['language', 'navigation', 'cart']
};

export const history = createBrowserHistory();
const persistedReducer = persistReducer(persistConfig, rootReducers(history));
const historyRouterMiddleware = routerMiddleware(history);

export default () => {
    // let store = createStore(persistedReducer, applyMiddleware(thunk, historyRouterMiddleware, createLogger));
    let store = createStore(persistedReducer, applyMiddleware(thunk, historyRouterMiddleware));
    let persistor = persistStore(store);

    /*
     * code from below not working fine :(
     */

    // if (module.hot) {
    //     module.hot.accept('../reducers', () => {
    //         // This fetch the new state of the above reducers.
    //         const nextRootReducer = require('../reducers').default;
    //         store.replaceReducer(persistReducer(persistConfig, nextRootReducer));
    //     });
    // }

    return { store, persistor };
};
